<template>
    <div class="btn-group" v-bind="$attrs">
        <BaseButton 
            id="dropdownMenuClickableInside" 
            class="btn--filter" 
            variant="outline" 
            variant-style="secondary"
            aria-expanded="false" 
            is-content
            v-bind="$attrs"
            data-bs-toggle="dropdown" 
            data-bs-auto-close="true" 
        >
            <template #content>
                <span class="flex align-items-center">
                    <IconSvg name="filter" fill="#637579" width="12px" height="12px" />
                    <span class="ml--5">Filter</span>
                    <CountBadge :value="filterActive.count" class="ml--5" />
                </span>
            </template>
        </BaseButton>

        <div class="dropdown-menu filter__dropdown-menu mb--35">
            <form class="overflow-y-scroll max-h-500" @submit.prevent="">
                <div class="action--btns__wrap">
                    <button class="action--btns__clear action--btns" type="reset" @click="clearFilter">
                        Clear all
                    </button>
                    <BaseButton 
                        label="Run" 
                        :disabled="disabled" 
                        type="submit" 
                        @submit="handleFilter"
                    />
                </div>

                <div class="mb--15">
                    <div v-if="filter.name.allowedPaths.includes(pageType)" class="filter-item-input">
                        <FormLabel title="Name" />
                        <input id="name" v-model="filter.name.value" class="form-control form-control-sm filter-input" type="text">
                    </div>

                    <div v-if="filter.currency.allowedPaths.includes(pageType)" class="filter-item-input">
                        <FormLabel title="Currency" classes="ml--0" />
                        <!-- <CustomDropdown 
                            id="currencyDropdown" 
                            v-model="filter.currency.value" 
                            :options="initialCurrencyList"
                            list-type="currencies" 
                            index-label="currency" 
                            size="sm"
                            multiple
                            :add-on="selectedCurrency.symbol"
                            class="dropdown-currency" 
                            btn-text-class="text--upper" 
                            @search="searchCurrencies" 
                            @select="selectCurrency" 
                        /> -->
                        <!-- <select v-model="filter.currency.value" class="form-select form-select-sm text--sm filter-input text--capitalize">
                            <option v-for="(industry, index) in initialCurrencyList" :key="index" :value="industry">
                                {{ industry }}
                            </option>
                        </select> -->
                    </div>

                    <div v-if="filter.industry.allowedPaths.includes(pageType)" class="filter-item-input">
                        <FormLabel title="Industry" />
                        <select v-model="filter.industry.value" class="form-select form-select-sm text--sm filter-input text--capitalize">
                            <option v-for="(industry, index) in industryData" :key="index" :value="industry">
                                {{ industry }}
                            </option>
                        </select>
                    </div>

                    <div v-if="filter.email.allowedPaths.includes(pageType)" class="filter-item-input">
                        <FormLabel title="Email" />
                        <input id="email" v-model="filter.email.value" class="form-control form-control-sm filter-input" type="email">
                    </div>

                    <div v-if="filter.status.allowedPaths.includes(pageType)" class="filter-item-input">
                        <FormLabel title="Status" />
                        <div>
                            <div v-for="status in statusList" :key="status" class="form-check form-check-inline">
                                <input
                                    :id="`status-${status}`" v-model="filter.status.value" class="form-check-input" type="checkbox"
                                    :value="status"
                                >
                                <label class="form-check-label text--capitalize" :for="`status-${status}`">{{ status }}</label>
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="filter.title.allowedPaths.includes(pageType)" class="filter-item-input">
                        <FormLabel title="Title" />
                        <input id="projectTitle" v-model="filter.title.value" class="form-control form-control-sm filter-input" type="text">
                    </div>

                    <div v-if="filter.projectType.allowedPaths.includes(pageType)" class="filter-item-input">
                        <FormLabel title="Project type" />
                        <select v-model="filter.projectType.value" class="form-select form-select-sm text--sm filter-input text--capitalize">
                            <option v-for="status in ['paid', 'not paid']" :key="status" :value="status" class="text--capitalize">
                                {{ status }}
                            </option>
                        </select>
                    </div>

                    <div v-if="filter.priority.allowedPaths.includes(pageType)" class="filter-item-input">
                        <FormLabel title="Priority" />
                        <div>
                            <div v-for="priority in priorities" :key="priority" class="form-check form-check-inline">
                                <input
                                    id="inlineCheckbox1" v-model="filter.priority.value" class="form-check-input" type="checkbox"
                                    :value="priority"
                                >
                                <label class="form-check-label text--capitalize" for="inlineCheckbox1">{{ priority }}</label>
                            </div>
                        </div>
                    </div>

                    <div v-if="filter.rateType.allowedPaths.includes(pageType)" class="filter-item-input">
                        <FormLabel title="Rate card type" />
                        <div>
                            <div v-for="item in rateTypes" :key="item" class="form-check form-check-inline">
                                <input
                                    :id="`check-${item}`" v-model="filter.rateType.value" :value="item" class="form-check-input"
                                    type="checkbox"
                                >
                                <label class="form-check-label text--capitalize" :for="`check-${item}`">{{ item }}</label>
                            </div>
                        </div>
                    </div>

                    <div v-if="filter.type.allowedPaths.includes(pageType)" class="filter-item-input">
                        <FormLabel title="Field type" />
                        <select v-model="filter.type.value" class="form-select form-select-sm text--sm filter-input text--capitalize">
                            <option v-for="(item, index) in listByFilterType" :key="index" :value="item">
                                {{ item }}
                            </option>
                        </select>
                    </div>

                    <div v-if="filter.invoiceNo.allowedPaths.includes(pageType)" class="filter-item-input">
                        <FormLabel title="Invoice No." />
                        <input id="invoiceNo" v-model="filter.invoiceNo.value" class="form-control form-control-sm" type="text">
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { 
    projectFilterStatuses, 
    priorities, 
    taskStatus, 
    invoiceFilterStatuses, 
    clientFilterStatuses, 
} from "@/utils/enums";
import { industryData, rateTypes } from "@/utils/dummy";
import { serilaizeQuery } from "@/utils/helpers";
import FormLabel from "../forms/FormLabel.vue";
import IconSvg from "../icons/Icon-Svg.vue";
import BaseButton from "../buttons/BaseButton.vue";
import CountBadge from "../badges/CountBadge.vue";

export default {
    name: "MainFilter",

    components: {
        FormLabel,
        IconSvg, 
        BaseButton,
        CountBadge,
    },

    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        pageType: {
            type: String,
            default: "",
        },
    },

    data() {
        return {
            query: {},
            projectFilterStatuses,
            priorities,
            taskStatus,
            invoiceFilterStatuses,
            clientFilterStatuses,
            industryData,
            currentPathName: this.$route.path || "",
            filter: this.getInitialFilterValues(),
            rateTypes,
            initialCurrencyList: Object.values(this.$currencies_obj),
            selectedCurrency: {},
            currencyMap: this.$supported_currencies_map,
        };
    },

    computed: {
        statusList() {
            switch (this.pageType) {
            case "projects":
                return this.projectFilterStatuses;
                
            case "invoices":
                return this.invoiceFilterStatuses;
                    
            case "clients":
                return this.clientFilterStatuses;
                    
            case "tasks":
                return this.taskStatus;
                
            default:
                return [];
            }
        },

        filterActive() {
            const values = Object.values(this.filter);
            let isActive = true;
            let count = 0;

            if (values.length) {
                for (let val of values) {                    
                    if (val?.value && val?.value !== null) {                        
                        if (Array.isArray(val.value) && val.value.length) {
                            console.log(Array.isArray(val.value) && val.value.length);
                            
                            isActive = true;
                            count++;
                        } 
                        
                        if (typeof val.value === "string") {
                            isActive = true;
                            count++;
                        }
                    } 
                }
            }

            return {
                isActive,
                count,
            };
        },

        listByFilterType() {
            switch (this.pageType) {
            case "reports":
                return ["clients", "projects", "invoices"];
            
            default:
                return [];
            }
        },
    },

    methods: {
        getInitialFilterValues() {            
            const filterData = {
                rateType: { allowedPaths: ["rateCards"], value: this.$route.query.rateType?.split(",") || [] },
                name: { allowedPaths: ["clients", "tags", "tasks"], value: this.$route.query.name || "" },
                industry: { allowedPaths: ["clients"], value: this.$route.query.industry || "" },
                priority: { allowedPaths: ["projects", "tasks"], value: this.$route.query.priority?.split(",") || [] },
                email: {
                    allowedPaths: ["clients", "invoices", "meetings"],
                    value: this.$route.query.email || "",
                },
                title: { 
                    allowedPaths: ["projects", "rateCards", "meetings"], value: this.$route.query.title || "", 
                },
                status: { allowedPaths: ["projects", "clients", "invoices", "meetings"], value: this.$route.query?.status?.split(",") || [] },
                invoiceNo: { allowedPaths: ["invoices"], value: this.$route.query.invoiceNo || "" },
                currency: { 
                    allowedPaths: ["invoices", "rateCards", "revenue"], 
                    value: this.$route.query.currency || "", 
                },
                projectType: { allowedPaths: ["projects"], value: this.$route.query.projectType || "" },
                type: { allowedPaths: ["reports"], value: this.$route.query.type || "" },
            };

            if (this.pageType === "reports") {
                filterData.type.value = "clients";
            }

            return filterData;
        },

        clearFilter() {
            const currentRoute = this.$route.path;
            const queryParam = serilaizeQuery({});
            
            this.$router.replace(`${currentRoute}?${queryParam}`);
        },

        handleFilter() {
            const query = this.query;

            if (this.$route.query.page){
                delete query.page;
            }

            if (this.$route.query.limit){
                delete query.limit;
            }

            if (this.filter.name.value) {
                query.name = this.filter.name.value;
            }

            if (this.filter.title.value) {
                query.title = this.filter.title.value;
            }

            if (this.filter.industry.value) {
                query.industry = this.filter.industry.value;
            }

            if (this.filter.email.value) {
                query.email = this.filter.email.value;
            }

            if (this.filter.status.value.length) {
                query.status = this.filter.status.value;
            }

            if (this.filter.currency.value) {
                query.currency = this.filter.currency.value;
            }

            if (this.filter.invoiceNo.value) {
                query.invoiceNo = this.filter.invoiceNo.value;
            }

            if (this.filter.priority.value.length) {
                query.priority = this.filter.priority.value;
            }

            if (this.filter.rateType.value.length) {
                query.rateType = this.filter.rateType.value;
            }

            if (this.filter.projectType.value) {
                query.projectType = this.filter.projectType.value;
            }

            if (this.filter.type.value) {
                query.type = this.filter.type.value;
            }

            const currentRoute = this.$route.path;
            const queryParam = serilaizeQuery(query);

            console.log({ currentRoute, queryParam });    
                        
            this.$router.replace(`${currentRoute}?${queryParam}`);
        },

        selectStatus(val) {
            const item = this.filter.status.value.find(x => x?._id === val?._id);

            if (!item) {
                filter.status.value = [ ...filter.status.value, val];
            };
        },

        removeStatusItem(item) {
            filter.status.value = filter.status.value.filter(x => x?._id !== item?._id);
        },

        searchCurrencies(val) {
            const initialList = this.initialCurrencyList;

            if (val && typeof val === "string") {
                const filteredList = initialList.filter(item => item.toLowerCase().includes(val.toLowerCase()));
                this.initialCurrencyList = filteredList;
            } else {
                this.initialCurrencyList = Object.values(this.$currencies_obj);
            }
        },

        selectCurrency(item) {
            const index = item && item.toLowerCase() || "";

            this.selectedCurrency = this.currencyMap[index];
            this.filter.currency.value = item;
        },
    },
};
</script>

<style lang="scss" scoped>
    .action--btns__wrap {
        border-bottom: 1px solid #eee;
        padding-bottom: 10px;
        padding-top: 10px;
        background-color: #f6f8fa !important;
        width: 100%;
        position: sticky;
        top: 0;
        z-index: 10;
    }

    .dropdown-menu.show {
        transform: translate3d(-10px, 30px, 0px) !important;
        transform: translate3d(0px, 30px, 0px) !important;
        width: 340px !important;
        inset: 0px 0px auto auto !important;
        padding: 0px !important;
        box-shadow: inset 0 -1px rgba(235, 238, 241, 0) !important; 
        border-radius: 5px;
   }

   .filter {
        &-input {
            font-size: 12px !important;
            border-radius: 6px;
        }

        &-item-input {
            display: flex;
            flex-direction: column;
            padding: 10px 11px;

            &:not(:last-of-type) {
                border-bottom: 1px solid #eee;
            }

            &:last-of-type {
                padding-bottom: 0px;
            }

            label {
                font-size: 12px !important;
            }
        }

        &-status {
            &-item {
                flex-direction: row !important;
                flex-wrap: wrap;

                label {
                    margin-bottom: 0px !important;
                }
            }
        }
   }
</style>